import { render, staticRenderFns } from "./register-form.vue?vue&type=template&id=380ef228&scoped=true&"
import script from "./register-form.vue?vue&type=script&lang=js&"
export * from "./register-form.vue?vue&type=script&lang=js&"
import style0 from "./register-form.vue?vue&type=style&index=0&id=380ef228&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "380ef228",
  null
  
)

export default component.exports